import axios from 'src/utils/axios';
import authService from 'src/services/authService';

export const LOGIN_REQUEST = '@account/login-request';
export const LOGIN_SUCCESS = '@account/login-success';
export const LOGIN_FAILURE = '@account/login-failure';
export const SILENT_LOGIN = '@account/silent-login';
export const LOGOUT = '@account/logout';
export const REGISTER = '@account/register';
export const UPDATE_PROFILE = '@account/update-profile';

export function loginHub(username, password) {
  return async dispatch => {
    try {
      dispatch({ type: LOGIN_REQUEST });

      const user = await authService.loginWithEmailAndPasswordHub(
        username,
        password
      );


      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          user: {
            NomeEmpresa: user.name,
            NomeUsuario: user.name,
            Perfil: user.name === 'Master' ? '0' : user.perfil,
          },
          type: user.name === 'Master' || !!user.idPartner ? 'admin' : 'hub',
        },
      });
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export function setUserData(user, type) {
  return dispatch =>
    dispatch({
      type: SILENT_LOGIN,
      payload: {
        user,
        type: type || 'cigam',
      },
    });
}

export function logout() {
  return async dispatch => {
    authService.logout();

    dispatch({
      type: LOGOUT,
    });
  };
}

export function register() {
  return true;
}

export function updateProfile(update) {
  const request = axios.post('/api/account/profile', { update });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_PROFILE,
        payload: response.data,
      })
    );
  };
}
